import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64158561"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deactivate_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "deactivate_title" }, "退会のお手続き", -1))
const _hoisted_3 = { class: "deactivate_question" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deactivate_question_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_text" }, "【Q1】退会を希望する理由を教えてください"),
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "deactivate_question_radio" }
const _hoisted_6 = {
  key: 0,
  class: "deactivate_question_radio"
}
const _hoisted_7 = { class: "deactivate_question_radio" }
const _hoisted_8 = { class: "deactivate_question_radio" }
const _hoisted_9 = {
  key: 1,
  class: "deactivate_question_radio"
}
const _hoisted_10 = { class: "deactivate_question" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deactivate_question_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_text" }, "【Q2】マスメディアンの総合評価をお聞かせください"),
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_optional" }, "任意")
], -1))
const _hoisted_12 = { class: "deactivate_question_radio" }
const _hoisted_13 = { class: "deactivate_question_radio" }
const _hoisted_14 = { class: "deactivate_question_radio" }
const _hoisted_15 = { class: "deactivate_question_radio" }
const _hoisted_16 = { class: "deactivate_question" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deactivate_question_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_text" }, " 【Q3】マスメディアンのサービスや担当者に関して、ご意見・ご感想・ご要望などございましたら、忌憚なくお書きください "),
  /*#__PURE__*/_createElementVNode("span", { class: "deactivate_question_title_optional" }, "任意")
], -1))
const _hoisted_18 = { class: "deactivate_question_textarea" }
const _hoisted_19 = { class: "deactivate_button" }
const _hoisted_20 = { class: "deactivate_button_reset" }
const _hoisted_21 = { class: "deactivate_button_send" }

import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { putDeactivate } from '@/api/accountEndpoint';
import { ref } from 'vue';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'DeactivateView',
  setup(__props) {

const breadcrumbs = [
  {
    label: 'ホーム',
    name: 'f00',
  },
  {
    label: '退会手続き',
  },
];
const router = useRouter();
const isLoading = ref(false);
const { meta, resetForm, errors } = useForm();
const { value: q1Value } = useField<number>('q1', validationRuleHelper({ required: true }));
const { value: q1companyValue, meta: q1companyMeta } = useField<string>('q1company', validationRuleHelper({ max: 200 }));
const { value: q1OtherValue, meta: q1OtherMeta } = useField<string>('q1Other', validationRuleHelper({ max: 200 }));
const { value: q2Value } = useField<number>('q2');
const { value: q3Value } = useField<string>('q3', validationRuleHelper({ max: 2000 }), {
  label: 'ご意見・ご感想・ご要望',
});

const reset = () => {
  resetForm();
};

const send = async () => {
  isLoading.value = true;

  try {
    await putDeactivate({
      withdrawalReason: q1Value.value,
      newCompany: q1Value.value === 1 && q1companyValue.value ? q1companyValue.value : undefined,
      withdrawalReasonOther: q1Value.value === 3 && q1OtherValue.value ? q1OtherValue.value : undefined,
      comprehensiveEvaluation: q2Value.value,
      opinion: q3Value.value,
    });

    router.push({ name: 'p10' });
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createVNode(Breadcrumbs, { breadcrumbs: breadcrumbs }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BaseRadioButton, {
            label: "転職先が決まったため",
            name: "q1",
            value: "1",
            modelValue: _unref(q1Value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(q1Value) ? (q1Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        (_unref(q1Value) === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(BaseTextForm, {
                placeholder: "差し支えなければ会社名を教えてください",
                modelValue: _unref(q1companyValue),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(q1companyValue) ? (q1companyValue).value = $event : null)),
                isError: !_unref(q1companyMeta).valid,
                maxlength: 200
              }, null, 8, ["modelValue", "isError"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseRadioButton, {
            label: "転職活動を停止したため",
            name: "q1",
            value: "2",
            modelValue: _unref(q1Value),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(q1Value) ? (q1Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseRadioButton, {
            label: "その他",
            name: "q1",
            value: "3",
            modelValue: _unref(q1Value),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(q1Value) ? (q1Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        (_unref(q1Value) === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(BaseTextForm, {
                placeholder: "差し支えなければ具体的に教えてください",
                modelValue: _unref(q1OtherValue),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(q1OtherValue) ? (q1OtherValue).value = $event : null)),
                isError: !_unref(q1OtherMeta).valid,
                maxlength: 200
              }, null, 8, ["modelValue", "isError"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseRadioButton, {
            label: "大変満足",
            name: "q2",
            value: "1",
            modelValue: _unref(q2Value),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(q2Value) ? (q2Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseRadioButton, {
            label: "満足",
            name: "q2",
            value: "2",
            modelValue: _unref(q2Value),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(q2Value) ? (q2Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseRadioButton, {
            label: "普通",
            name: "q2",
            value: "3",
            modelValue: _unref(q2Value),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(q2Value) ? (q2Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseRadioButton, {
            label: "不満",
            name: "q2",
            value: "4",
            modelValue: _unref(q2Value),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(q2Value) ? (q2Value).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseTextareaForm, {
            name: "q3",
            maxCount: 2000,
            rows: 10,
            placeholder: "入力してください。",
            modelValue: _unref(q3Value),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(q3Value) ? (q3Value).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        (_unref(errors).q3)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: [_unref(errors).q3]
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode("リセット")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseButton, {
            theme: "primary",
            disabled: !_unref(meta).valid,
            onClick: send
          }, {
            default: _withCtx(() => [
              _createTextVNode("送信")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})